/* eslint-disable no-irregular-whitespace */
import { Injectable } from '@angular/core';
import { AmountInterface } from '../../layout/interfaces/amount-interface';

/**
 * lightweight standardized AmountInterface => '12,49 €' | '12 €' converter
 * DO NOT make it any bigger here since it will be used basically everywhere we render prices
 * Create another service and inject this service if you want to make calculations like 'sum up' or something
 */
@Injectable({
  providedIn: 'root'
})
export class ExchangeCalculatorService {
  /**
   *
   * @param amount AmountInterface you want to render in a currency format
   * @param to the currency you want to exchange it for (EUR|USD|CZK|...)
   * @param decimals how many decimals you want to render 2 = 12,49, 1 = 12,4 0 = 12, Amount is rounded before cut off
   * @param withCurrencyCode if you want the number with currency sign
   * @param raw if you want a nonbreaking space to render in a template
   * @returns string representing the given amount in the given currency
   */
  exchange(amount: AmountInterface, to: string, decimals = 2, withCurrencyCode = true): string {
    const exchangedAmount = (
      ((amount.currency.code === to
        ? 1
        : amount.currency.rates[to] / amount.currency.rates[amount.currency.code]) *
        amount.amount) /
      100
    ).toFixed(decimals);

    if (withCurrencyCode) {
      return this.formatOutput(exchangedAmount, to);
    }
    return exchangedAmount;
  }

  private formatOutput(exchangedAmount: string | number, to: string): string {
    switch (to) {
      case 'USD':
        return `${exchangedAmount} $`;
      case 'CHF':
        return `Fr.${exchangedAmount}`;
      case 'GBP':
        return `£${exchangedAmount}`;
      case 'CZK':
        return `Kč ${exchangedAmount}`;
      case 'PLN':
        return `${exchangedAmount} zł`;
      default: {
        return `${exchangedAmount} €`;
      }
    }
  }

  private exchangeCents(amount: AmountInterface, to: string): number {
    return (amount.currency.rates[to] / amount.currency.rates[amount.currency.code]) * amount.amount;
  }

  subtract(amounts: AmountInterface[], currency: string): string {
    let result: number;
    amounts.forEach(amount => {
      if (!result) {
        result = +(this.exchangeCents(amount, currency) / 100).toFixed(2); // to pound
      } else {
        result = +(+result - +(this.exchangeCents(amount, currency) / 100).toFixed(2)).toFixed(2); //
      }
    });
    // TODO: add formatting
    return this.formatOutput(result.toFixed(2), currency);
  }
}
